import { render, staticRenderFns } from "./DiagnosticUpdateForm.vue?vue&type=template&id=38488e15&scoped=true"
import script from "./DiagnosticUpdateForm.vue?vue&type=script&lang=js"
export * from "./DiagnosticUpdateForm.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticUpdateForm.vue?vue&type=style&index=0&id=38488e15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38488e15",
  null
  
)

export default component.exports